export default __webpack_public_path__ + "static/dod-907c0b85e10c2ec57230057480e3470c.png";